import { render, staticRenderFns } from "./FilterColor.vue?vue&type=template&id=51570937&"
import script from "./FilterColor.vue?vue&type=script&lang=js&"
export * from "./FilterColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports